import React from 'react';

const formInitialObject = {
  isNotValid: false,
  hasFormChanged: false,
  hasErrorFunc: () => {}
};

export const FormValidatorContext = React.createContext(formInitialObject);
